export default __webpack_public_path__ + "static/media/finish_call_icon.9ef08145.svg";